import { COUNTRY_OPTIONS } from '../BusinessDetails';

export const ADDRESS_FIELD = 'address';
export const ADDRESS_OPTIONAL_FIELD = 'addressOptional';
export const CITY_FIELD = 'city';
export const COUNTRY_FIELD = 'country';
export const POSTAL_CODE_FIELD = 'zip';
export const STATE_FIELD = 'state';

export const ADDRESS_FIELDS = {
  [ADDRESS_FIELD]: {
    autoComplete: 'off',
    placeholder: 'Business Address',
  },
  [ADDRESS_OPTIONAL_FIELD]: {
    placeholder: 'Suite/Unit/Building (optional)',
  },
  [CITY_FIELD]: {
    placeholder: 'City',
  },
  [COUNTRY_FIELD]: {
    placeholder: 'Country',
    selectList: COUNTRY_OPTIONS,
  },
  [POSTAL_CODE_FIELD]: {
    placeholder: 'ZIP/Postal Code',
  },
  [STATE_FIELD]: {
    placeholder: 'State/Province',
  },
};

export const EMAIL_FIELD = 'email';
export const FIRST_NAME_FIELD = 'firstName';
export const LAST_NAME_FIELD = 'lastName';
export const PASSWORD_FIELD = 'password';
export const PHONE_FIELD = 'phone';

export const CONTACT_FIELDS = {
  [EMAIL_FIELD]: {
    fieldName: EMAIL_FIELD,
    placeholder: 'Email',
  },
  [FIRST_NAME_FIELD]: {
    fieldName: FIRST_NAME_FIELD,
    placeholder: 'First name',
  },
  [LAST_NAME_FIELD]: {
    fieldName: LAST_NAME_FIELD,
    placeholder: 'Last name',
  },
  [PHONE_FIELD]: {
    fieldName: PHONE_FIELD,
    placeholder: 'Phone number',
  },
};
